import Vue from 'vue';
import translation from '@/assets/rawData/i18n/whitelistsPage.json';
import applyPageI18NMessages from '@/vue-utils/i18n';
export default Vue.extend({
    name: 'whitelistsPage',
    created() {
        applyPageI18NMessages(this, 'whitelistsPage', translation);
    }
});
